<template>
  <router-view />
</template>

<script>
import storeMixin, { unRegisterMixin } from '@/shared/mixins/storeGenerator';

export default {
  name: 'UmesrWrapper',
  mixins: [unRegisterMixin, storeMixin],
  destroyed() {
    this.persistData();
  },
};
</script>
